module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1043-26ef009a186a3fc012514771267704e0.png";